<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="opening_date"
    >
      <span>{{ trans('addresses.details.form.field.opening_date.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--small field-input--date">
      <vue-date-picker
        v-model="openingDate"
        name="opening_date"
        format="dd/MM/yyyy"
        locale="fr"
        :class="{ error: error }"
        :enable-time-picker="false"
        auto-apply
      />
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { momentMixin } from '@tools/moment';
import VueDatePicker from '@vuepic/vue-datepicker';

export default {
  components: { VueDatePicker },
  mixins: [ translationMixin, momentMixin ],
  props: {
    modelValue: { type: String, required: false, default: null },
    error: { type: String, required: false, default: null },
    validationRules: { type: Object, required: true },
  },
  computed: {
    openingDate: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.emitValue(this.getSimpleDate(value));
      },
    },
  },
  methods: {
    emitValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('focusout');
    },
  },
};
</script>
